import {
    TablePage,
    ViewPage,
    EditPage
}  from 'src/views/clog/cia-admin/party-config'
import pathMap from 'src/paths/pathMap'

class CalistaAdvisoryPartyConfigRoute{
    getConfigurations(){
        return[
            {
                exact: true,
                path: pathMap.CALISTA_ADVISORY_ADMIN_PARTY_CONFIG_LIST_VIEW,
                component: TablePage
            },
            {
                exact: true,
                path: pathMap.CALISTA_ADVISORY_ADMIN_PARTY_CONFIG_DETAILS_VIEW,
                component: ViewPage
            },
            {
                exact:true,
                path: pathMap.CALISTA_ADVISORY_ADMIN_PARTY_CONFIG_EDIT_VIEW,
                component: EditPage
            }
        ]
    }
}

export default CalistaAdvisoryPartyConfigRoute